const credentials = [
  { icon: 'ri-scales-line', text: 'Especialista em Direito Previdenciário' },
  { icon: 'ri-time-line', text: 'Atuando desde 2010' },
  { icon: 'ri-map-pin-line', text: 'Atendimento em todo o Brasil' },
  { icon: 'ri-shield-check-line', text: 'INSS e Militares' },
];

export default function AboutSection() {
  return (
    <section id="sobre" className="bg-brand-cream py-24 overflow-hidden">
      <div className="max-w-7xl mx-auto px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 xl:gap-20 items-center">

          {/* Left: Image */}
          <div className="relative">
            {/* Decorative background square */}
            <div className="absolute inset-0 translate-x-5 translate-y-5 bg-brand-gold/10 rounded-xl" />
            <div className="relative overflow-hidden rounded-xl w-full" style={{ aspectRatio: '4/5' }}>
              <img
                src="/images/ariani-mais-logo.webp"
                alt="Ariani Zanardo - Advogada Previdenciária"
                className="w-full h-full object-cover object-top"
              />
              {/* Overlay bottom */}
              <div className="absolute inset-x-0 bottom-0 h-28 bg-gradient-to-t from-brand-cream/60 to-transparent" />
            </div>

            {/* Floating badge */}
            <div className="absolute bottom-6 left-6 bg-white rounded-lg px-5 py-4 border border-brand-border">
              <p className="font-cormorant text-2xl font-semibold text-brand-dark leading-none mb-0.5">
                15+
              </p>
              <p className="font-inter text-xs text-brand-muted">Anos de experiência</p>
            </div>
          </div>

          {/* Right: Content */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-6 h-px bg-brand-gold" />
              <span className="font-inter text-xs font-medium text-brand-gold uppercase tracking-[0.18em]">
                Sobre a advogada
              </span>
            </div>

            <h2 className="font-cormorant text-4xl lg:text-5xl font-semibold text-brand-dark leading-tight mb-8">
              Especialista e apaixonada
              <br />
              pelo <span className="italic">Direito Previdenciário</span>
            </h2>

            <div className="space-y-4 mb-10">
              <p className="font-inter text-sm text-brand-muted leading-[1.9]">
                Sou advogada especialista e apaixonada pelo Direito Previdenciário, com ampla experiência na atuação técnica e estratégica em demandas administrativas e judiciais no âmbito do Regime Geral de Previdência Social (INSS) e também na Proteção Social dos Militares, desde 2010.
              </p>

              <p className="font-inter text-sm text-brand-muted leading-[1.9]">
                Aqui, acreditamos que cada história merece ser ouvida. Cada direito, protegido. Cada conquista, respeitada.
              </p>

              <p className="font-inter text-sm text-brand-muted leading-[1.9]">
                Não atuamos apenas com leis e processos. Atuamos com propósito, com a responsabilidade de transformar momentos difíceis em novos começos.
              </p>

              <p className="font-inter text-sm text-brand-muted leading-[1.9]">
                Nossa missão vai além do papel: é cuidar de vidas, preservar futuros e assegurar a dignidade de quem nos confia seus sonhos e seus medos.
              </p>

              <p className="font-inter text-sm text-brand-muted leading-[1.9]">
                Em cada atendimento, oferecemos mais do que estratégias jurídicas: oferecemos acolhimento, ética e respeito.
              </p>

              <p className="font-inter text-sm text-brand-muted leading-[1.9]">
                Acreditamos que a justiça é feita não apenas com palavras, mas com empatia, excelência técnica e ação.
              </p>

              <p className="font-inter text-sm text-brand-muted leading-[1.9]">
                Somos a advocacia que escuta. A advocacia que acolhe. A advocacia que transforma.
              </p>

              <p className="font-inter text-sm font-semibold text-brand-dark leading-[1.9]">
                Ariani Zanardo Advocacia — Direito com propósito. Justiça com humanidade.
              </p>
            </div>

            {/* Credentials grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {credentials.map((cred) => (
                <div
                  key={cred.text}
                  className="flex items-center gap-3 bg-white rounded-lg px-4 py-3 border border-brand-border"
                >
                  <div className="w-8 h-8 flex items-center justify-center bg-brand-cream rounded-md flex-shrink-0">
                    <i className={`${cred.icon} text-brand-gold text-sm`} />
                  </div>
                  <span className="font-inter text-xs text-brand-charcoal leading-snug">
                    {cred.text}
                  </span>
                </div>
              ))}
            </div>

            {/* WhatsApp CTA */}
            <div className="mt-8 flex items-center gap-4 p-5 bg-white border border-brand-border rounded-xl">
              <div className="w-10 h-10 flex items-center justify-center bg-[#25D366]/10 rounded-lg flex-shrink-0">
                <i className="ri-whatsapp-line text-[#25D366] text-xl" />
              </div>
              <div className="flex-1">
                <p className="font-inter text-xs font-semibold text-brand-dark mb-0.5">
                  Fale diretamente com a Ariani
                </p>
                <p className="font-inter text-xs text-brand-muted">
                  Atendimento personalizado para o seu caso
                </p>
              </div>
              <a
                href="https://api.whatsapp.com/send?phone=5551996057679&text=Ol%C3%A1,%20vim%20do%20seu%20site%20e%20gostaria%20de%20falar%20com%20um%20advogado."
                target="_blank"
                rel="noopener noreferrer"
                className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#20ba5a] text-white font-inter font-semibold text-xs px-5 py-2.5 rounded-md transition-all duration-200"
              >
                Conversar agora
                <i className="ri-arrow-right-line text-sm" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
